module.exports = __webpack_public_path__ + "static/media/xenon-result.b63edc06.png";